import { Box } from '@mui/material';
import starterIcon from '../../assets/grades/starter.png';
import listenerIcon from '../../assets/grades/listener.png';
import collectorIcon from '../../assets/grades/collector.png';
import curatorIcon from '../../assets/grades/curator.png';

const GRADE_ICONS = {
  STARTER: starterIcon,
  LISTENER: listenerIcon,
  COLLECTOR: collectorIcon,
  CURATOR: curatorIcon,
};

const GradeIcon = ({ grade, size = 16 }) => {
  const icon = GRADE_ICONS[grade];
  if (!icon) return null;

  return (
    <Box component="img" src={icon} alt={grade} sx={{ width: size, height: size, flexShrink: 0 }} />
  );
};

export default GradeIcon;
